import { Cell } from '../../../common/interfaces';
import { isStringNumber } from '../../../common/utils';

export const canCellValueBeFormattedAsNumber = ({ value, objectValue, format }: Pick<Cell, 'value' | 'objectValue' | 'format'>) => {
    const objectValueOrValue = objectValue || value;
    return typeof objectValueOrValue === 'number' || (format && isStringNumber(objectValueOrValue));
};